import { workReportLineStatus } from '../../utils/dataStatus';
import { formatFullDate, formatsEnum } from '../../utils/formatUtils';

const isLeapYear = (year) => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

const isValidDate = (dateString) => {
  const datePattern = /^(0?[1-9]|1\d|2[0-8])(\/|-|\.)(0?[1-9]|1[0-2])\2(\d{4})$/;
  const leapYearPattern = /^(29)(\/|-|\.)(0?2)\3(\d{4})$/;
  const thirtyDaysPattern = /^(29|30)(\/|-|\.)(0?[13-9]|1[0-2])\2(\d{4})$/;
  const thirtyOneDaysPattern = /^(31)(\/|-|\.)(0?[13578]|1[02])\2(\d{4})$/;

  if (datePattern.test(dateString)) {
    return true;
  }

  if (leapYearPattern.test(dateString)) {
    const [, , , , year] = leapYearPattern.exec(dateString);

    return isLeapYear(parseInt(year, 10));
  }

  return thirtyDaysPattern.test(dateString) || thirtyOneDaysPattern.test(dateString);
};

const newLineToPush = (
  ubicationId,
  PartJobLineId,
  dailyPartJobLineId,
  quantity,
  bloqueadoEnSap,
  habilitaNotificacion
) => ({
  ubicacion_id: ubicationId,
  lineas: [
    {
      parte_trabajo_linea_id: PartJobLineId,
      bloqueadoEnSap,
      cantidades: [
        {
          id: dailyPartJobLineId,
          cantidad: quantity,
          habilitaNotificacion
        }
      ]
    }
  ]
});

const getQuantitesToPost = (arrayWithQuantities) => {
  const quantities = [];

  arrayWithQuantities?.forEach((ubication) => {
    ubication.lineas
      ?.filter((line) => !line.bloqueadoEnSap)
      .forEach((line) => {
        line.cantidades.forEach((quantity) => {
          if (quantity.cantidad > 0 && quantity?.habilitaNotificacion) quantities.push(quantity);
        });
      });
  });

  return quantities;
};

const lineWasEdited = (initialReturnedLine, editedReturnedLine) => {
  if (
    editedReturnedLine === null ||
    editedReturnedLine === undefined ||
    initialReturnedLine === null ||
    initialReturnedLine === undefined
  ) {
    return false;
  }

  return initialReturnedLine.cantidad !== editedReturnedLine.cantidad;
};

const isAllReturnedLineEdited = (originalArray, editedArray) => {
  let numberOfDiference = 0;

  originalArray.forEach((returnedLine) => {
    if (
      lineWasEdited(
        returnedLine,
        editedArray.filter((returnedLine2) => returnedLine.id === returnedLine2.id)[0]
      )
    ) {
      numberOfDiference += 1;
    }
  });

  return numberOfDiference === editedArray.length;
};

const getReturnedsQuantities = (quantities) => {
  const today = new Date();

  return quantities
    .filter(
      (quantity) =>
        quantity.estadoEnum === workReportLineStatus.devolver ||
        quantity.estadoEnum === workReportLineStatus.pendiente
    )
    .filter(
      (quantity) => new Date(formatFullDate(quantity.fecha, formatsEnum.FORMAT_DATE_2)) < today
    )
    .map((quantity) => ({
      id: quantity.idParteTrabajoDiario,
      cantidad: quantity.cantidad,
      habilitaNotificacion: quantity.habilitaNotificacion
    }));
};

const newReturnedUbication = (ubication) => {
  const objectToPush = {
    ubicacion_id: ubication.idUbicacion,
    lineas: ubication.lineas.map((line) => ({
      parte_trabajo_linea_id: line.idParteTrabajoLinea,
      bloqueadoEnSap: line.bloqueadoEnSap,
      cantidades: getReturnedsQuantities(line.cantidades)
    }))
  };
  const filteredReturnedLines = {
    ...objectToPush,
    ...{
      lineas: objectToPush.lineas.filter((line) => line.cantidades.length > 0)
    }
  };

  if (filteredReturnedLines.lineas.length > 0) {
    return filteredReturnedLines;
  }

  return null;
};

const newReturnedUbicationOrderByPositionLine = (ubication, partJobLineId, bloqueadoEnSap) => {
  const objectToPush = {
    ubicacion_id: ubication.idUbicacion,
    lineas: [
      {
        parte_trabajo_linea_id: partJobLineId,
        bloqueadoEnSap,
        cantidades: getReturnedsQuantities(ubication.cantidades)
      }
    ]
  };
  const filteredReturnedLines = {
    ...objectToPush,
    ...{
      lineas: objectToPush.lineas.filter((line) => line.cantidades.length > 0)
    }
  };

  if (filteredReturnedLines.lineas.length > 0) {
    return filteredReturnedLines;
  }

  return null;
};

const processUbication = (ubication, auxReturnedsPJL) => {
  const newUbicationToPush = newReturnedUbication(ubication);

  if (newUbicationToPush) {
    auxReturnedsPJL.push(newUbicationToPush);
  }
};

const processPartJobLine = (partJobLine, auxReturnedsPJL) => {
  partJobLine.ubicaciones.forEach((ubication) => {
    const ubicationIds = auxReturnedsPJL?.map((ubiAux) => ubiAux.ubicacion_id);

    if (!ubicationIds.includes(ubication.idUbicacion)) {
      const returnedUbicationToPush = newReturnedUbicationOrderByPositionLine(
        ubication,
        partJobLine.idParteTrabajoLinea,
        partJobLine.bloqueadoEnSap
      );

      if (returnedUbicationToPush) {
        auxReturnedsPJL.push(returnedUbicationToPush);
      }
    } else {
      const index = ubicationIds.indexOf(ubication.idUbicacion);
      const ubicationSelected = auxReturnedsPJL[index];
      const { lineas } = ubicationSelected;
      const lineaIds = lineas.map((linea) => linea.parte_trabajo_linea_id);

      if (!lineaIds.includes(partJobLine.idParteTrabajoLinea)) {
        const objectToPush = {
          parte_trabajo_linea_id: partJobLine.idParteTrabajoLinea,
          bloqueadoEnSap: partJobLine.bloqueadoEnSap,
          cantidades: ubication.cantidades
            .filter((quantity) => quantity.estado === 'Devuelta')
            .map((quantity) => ({
              id: quantity.idParteTrabajoDiario,
              cantidad: quantity.cantidad,
              habilitaNotificacion: quantity.habilitaNotificacion || quantity.enableNotification
            }))
        };
        const filteredReturnedLines = {
          ...objectToPush,
          ...{
            lineas: objectToPush?.cantidades.filter(
              (quantities) => quantities.cantidades?.length > 0
            )
          }
        };

        if (filteredReturnedLines.cantidades.length > 0) {
          lineas.push();
        }
      } else {
        const indexLines = lineaIds.indexOf(partJobLine.idParteTrabajoLinea);
        const linea = lineas[indexLines];
        const { cantidades } = linea;

        cantidades.push(
          ...ubication.cantidades
            .filter((quantity) => quantity.estado === 'Devuelta')
            .map((quantity) => ({
              id: quantity.idParteTrabajoDiario,
              cantidad: quantity.cantidad,
              habilitaNotificacion: quantity.habilitaNotificacion || quantity.enableNotification
            }))
        );
      }
    }
  });
};

const setReturnedsPJLFunc = (
  isOrderByUbication,
  linesByUbication = [],
  linesByPostionLIne = []
) => {
  const auxReturnedsPJL = [];
  const auxLinesByUbication = [...linesByUbication];
  const auxLinesByPostionLIne = [...linesByPostionLIne];

  if (isOrderByUbication === 'true') {
    auxLinesByUbication?.forEach((ubication) => processUbication(ubication, auxReturnedsPJL));
  } else {
    auxLinesByPostionLIne.forEach((partJobLine) =>
      processPartJobLine(partJobLine, auxReturnedsPJL)
    );
  }

  return auxReturnedsPJL;
};

export {
  isValidDate,
  newLineToPush,
  getQuantitesToPost,
  lineWasEdited,
  isAllReturnedLineEdited,
  setReturnedsPJLFunc
};
